/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { fetchRetailStatus, isRetailSelector } from '../selectors/RetailSelectors';
import * as RequestStatus from 'pricing-pages-ui/actions/constants/RequestStatus';
export const useTrackRetail = () => {
  const isRetail = useSelector(isRetailSelector);
  const hasRetailFetchSucceeded = useSelector(fetchRetailStatus) === RequestStatus.SUCCEEDED;
  useEffect(() => {
    if (hasRetailFetchSucceeded) getUsageTracker().setProperties({
      isRetail
    });
  }, [hasRetailFetchSucceeded]);
};